module.exports = __webpack_public_path__ + "static/CrowdStrike-576a19cd9fa0afdabde6257811a879ea.jpg";